import { createAction, props } from '@ngrx/store';
import {
  BranchListItemResponse,
  PermissionItemResponse,
  PspBranchCreateRequest,
  PspBranchResponse,
} from '../../../api';

export const loadPspBranchList = createAction('[Psp Branch] Load list');
export const setPspBranchList = createAction(
  '[Psp Branch] Set list',
  props<{ payload: Array<BranchListItemResponse> }>()
);
export const successPspBranchList = createAction('[Psp Branch] List success');
export const errorPspBranchList = createAction('[Psp Branch] List error');
export const setPspBranchActiveCrud = createAction(
  '[Psp Branch] Set active status',
  props<{ payload: { branchId: number; setActive: boolean } }>()
);
export const createPspBranchCrud = createAction(
  '[Psp Branch] Create branch',
  props<{ payload: { body: PspBranchCreateRequest } }>()
);
export const successPspBranchCrud = createAction('[Psp Branch] Crud success');
export const errorPspBranchCrud = createAction('[Psp Branch] Crud error');
export const loadPspUserList = createAction('[Psp Branch] Load user list');
export const setPspUserList = createAction(
  '[Psp Branch] Set user list',
  props<{ payload: PermissionItemResponse[] | undefined }>()
);
export const successPspUserList = createAction('[Psp Branch] User list success');
export const errorPspUserList = createAction('[Psp Branch] User list error');

export const addBranchUsers = createAction(
  '[Psp Branch] Add user to PSP-branch',
  props<{ payload: { branch: number; users: number[] } }>()
);
export const deleteBranchUser = createAction(
  '[Psp Branch] Delete user from PSP-branch',
  props<{ payload: { branch: number; user: number } }>()
);
export const updateBranchUsers = createAction(
  '[Psp Branch] Update PSP-branch users',
  props<{ payload: { branch: number; users: number[] } }>()
);

export const loadBranch = createAction('[Psp Branch] Load Branch data', props<{ payload: { branch: number } }>());

export const updateBranch = createAction(
  '[Psp Branch] Update branch',
  props<{ payload: { branch: number; body: PspBranchResponse } }>()
);

export const setBranch = createAction('[Psp Branch] Set Branch data to store', props<{ payload: PspBranchResponse }>());
export const successBranch = createAction('[Psp Branch] Success branch');
export const errorBranch = createAction('[Psp Branch] Error branch');
export const resetBranch = createAction('[Psp Branch] Reset branch');

export const setBranchInactiveFilter = createAction(
  '[Shared] Set filter for inactive branches',
  props<{ filterActive: boolean }>()
);

export const sendIzsRequestInformation = createAction(
  '[Psp Branch] Send IZS Request Information',
  props<{ payload: number }>()
);
export const successSendIzsRequestInformation = createAction('[Psp Branch] Success Send IZS Request Information');
export const errorSendIzsRequestInformation = createAction('[Psp Branch] Error Send IZS Request Information');
